import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getEgresosTotalesEmpleado.php';

export default function getEgresosTotalesEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}